import { atom } from 'jotai'
import { TDictionary } from '../types/dictionary.type'

export const dictionaryState = atom<TDictionary>({
    en: {}
})
